import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private apiURL: string = '';

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
  }

  getReportList() {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http.get(this.apiURL + '/api/Reports', requestOptions).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((res: any) => {
        return throwError(res.json());
      }),
    );
  }

  getReportData(
    reportName: string,
    partnerID: number,
    startDate: string,
    endDate: string,
  ) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
          `/api/Reports/${reportName}/Partner/${partnerID}?startDate=${startDate}&endDate=${endDate}`,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
}
